import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common';

const states: Ng1StateDeclaration[] = [
    {
        name: 'tags',
        url: '/tags',
        component: 'wtTagsState',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer])
        },
        abstract: false,
        data: {
            visible: true,
            sortingOrder: 7,
            icon: 'fa-tags',
            displayName: 'Tags',
            editRoles: [Roles.master, Roles.engineer],
            editButtonVisibility: () => true,
            subStates: ['tagsStatistics', 'tag.general', 'tag.statistics', 'tag.shewhart']
        },
        params: {
            mode: 'tiles',
            searchString: ''
        }
    }
];

export default states;